import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=cfbde598&"
import script from "./MyCourses.vue?vue&type=script&lang=js&"
export * from "./MyCourses.vue?vue&type=script&lang=js&"
import style0 from "./MyCourses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfbde598')) {
      api.createRecord('cfbde598', component.options)
    } else {
      api.reload('cfbde598', component.options)
    }
    module.hot.accept("./MyCourses.vue?vue&type=template&id=cfbde598&", function () {
      api.rerender('cfbde598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCourses.vue"
export default component.exports